export enum LoyaltyType {
  ALL = 'all',
  PRIVILEGES = 'privileges',
  REWARD = 'rewards',
  BONUS_POINTS = 'bonus-points',
}
